import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { PersistenceEffects } from './persistence.effects';

/**
 * Registers the generic slice-persistence effects. Persisted slices contribute their
 * projection selector through the {@link PERSISTED_SLICES} multi-provider (declared in each
 * slice's own store module), so this module carries no per-slice knowledge.
 */
@NgModule({
    imports: [EffectsModule.forFeature([PersistenceEffects])],
})
export class PersistenceStoreModule {}
